import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme, type Theme } from '@/lib/theme';
import { cn } from '@/lib/cn';

const OPTIONS: Array<{ value: Theme; label: string; icon: typeof Sun }> = [
  { value: 'light',  label: 'Светлая', icon: Sun },
  { value: 'dark',   label: 'Тёмная',  icon: Moon },
  { value: 'system', label: 'Как в системе', icon: Monitor },
];

export function ThemeToggle({ compact }: { compact?: boolean }) {
  const [theme, setTheme] = useTheme();
  return (
    <div role="radiogroup" aria-label="Тема" className={cn('inline-flex items-center gap-0.5 rounded-lg border border-line bg-surface-2 p-0.5', compact ? 'h-8' : 'h-9')}>
      {OPTIONS.map(({ value, label, icon: Icon }) => (
        <button
          key={value}
          type="button"
          role="radio"
          aria-checked={theme === value}
          title={label}
          aria-label={label}
          onClick={() => setTheme(value)}
          className={cn(
            'flex h-full items-center gap-1.5 rounded-md px-2 text-xs font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40',
            theme === value ? 'bg-surface text-ink shadow-sm' : 'text-muted hover:text-ink',
          )}
        >
          <Icon size={14} />
          {!compact && <span className="hidden lg:inline">{label}</span>}
        </button>
      ))}
    </div>
  );
}
